const fadTriggerElement = document.getElementById('fadFilterTrigger');
const fadFilterElement = document.querySelector('.fad-filter');

if (fadFilterElement) {
  fadTriggerElement.addEventListener('click', (event) => {
    event.preventDefault();
    fadFilterElement.classList.toggle('is-active');
  });
}